import { render, staticRenderFns } from "./PlayerEmbedControler.vue?vue&type=template&id=d632c4ca&"
import script from "./PlayerEmbedControler.vue?vue&type=script&lang=js&"
export * from "./PlayerEmbedControler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports